// extracted by mini-css-extract-plugin
export default {"root":"zw1OqY","withOverlay":"ZzUbyt","bg":"mrPP2R","overlay":"H2KnpH"};